import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Page from 'components/pages/Page';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    column: {
      textAlign: 'left',
      color: theme.palette.text.secondary,
    }
  }),
);

export default function ContactUsPage(props: any) {
  const classes = useStyles();

  return (
    <Page>
      <Grid container>
        <Grid item xs={12}>
          <h1>Contact Us</h1>
          <div className={classes.column}>
            Please contact us with any questions, comments or suggestions you may have.
          </div>
        </Grid>
      </Grid>
    </Page>
  );
}